import React, { useEffect } from "react";
import { useState } from "react";

import Backend from "../../../../Backend/Backend";
import toast from "react-hot-toast";

const fmt = require("indian-number-format");

const backend = await new Backend().init();

export default function Total(props) {
  const user_id = props.user_id;

  const [loading, setLoading] = useState(false);

  const [profitloss, setProfitLoss] = useState(0);
  const [commission, setCommission] = useState(0);

  const [total, setTotal] = useState(0);

  const [master_total, setMasterTotal] = useState(0);

  const [broker_commission, setBrokerCommission] = useState(0);
  const [broker_total, setBrokerTotal] = useState(0);

  useEffect(() => {
    loadSettlement();
  }, [user_id]);

  const loadSettlement = () => {
    setLoading(true);
    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),

      start: props.start,
      end: props.end,
      user_id: user_id,
      total: "1",
    };

    backend.settlement_broker(data).then((r) => {
      setLoading(false);
      if (r.error == "False") {
        setProfitLoss(r.booked);
        setCommission(r.commission);

        setTotal(r.total);
        setMasterTotal(r.master_total);
        setBrokerCommission(r.broker_commission);
        setBrokerTotal(r.broker_total);
      } else {
        if (r.logout == 1) {
          window.LogOut();
        } else {
          toast.error(r.message);
        }
      }
    });
  };

  const formatAmountWithSign = (value) => {
    const num = parseFloat(value) || 0;
    const sign = num > 0 ? "+" : num < 0 ? "-" : "";
    return `${sign}${fmt.format(Math.abs(num))}`;
  };

  const formatAmountWithSig2 = (value) => {
    const num = parseFloat(value) || 0;
    const sign = num < 0 ? "+" : num > 0 ? "-" : "";
    return `${sign}${fmt.format(Math.abs(num))}`;
  };

  const getColorClass = (value) => {
    const num = parseFloat(value) || 0;
    return num >= 0 ? "buytext" : "selltext";
  };

  const getColorClass2 = (value) => {
    const num = parseFloat(value) || 0;
    return num <= 0 ? "buytext" : "selltext";
  };

  return (
    <div className="menuContainer font-semibold bg-[var(--hover)] text-[var(--text)] addHight white hover-border">
      <div className="menuExchange text-[var(--text)] ">TOTAL</div>

      <div className={`menuExchange ${getColorClass(profitloss)}`}>
        {formatAmountWithSign(profitloss)}
      </div>

      <div
        className={`menuExchange ${getColorClass(
          parseFloat(profitloss) + parseFloat(commission),
        )}`}
      >
        {formatAmountWithSign(parseFloat(profitloss) + parseFloat(commission))}
      </div>

      <div className={`menuExchange ${getColorClass(commission)}`}>
        {formatAmountWithSign(commission)}
      </div>

      <div className={`menuExchange ${getColorClass(broker_commission)}`}>
        {formatAmountWithSign(broker_commission)}
      </div>

      <div className={`menuExchange ${getColorClass2(total)}`}>
        {formatAmountWithSig2(total)}
      </div>

      <div className="menuExchange text-[var(--text)]">-</div>

      <div className={`menuExchange  ${getColorClass2(broker_total)}`}>
        {formatAmountWithSig2(broker_total)}
      </div>

      <div className={`menuExchange ${getColorClass2(master_total)}`}>
        {formatAmountWithSig2(master_total)}
      </div>
    </div>
  );
}
